
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class Loader extends Vue {
  @Prop({ type: Boolean, default: false })
  private readonly small!: boolean
}
